(ns app.front.view.wizard.project-selector
  (:require [app.domain.municipality.model :as municipality-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.tabs :as ui-tabs]
            [app.front.util :as futil]
            [app.front.view.wizard.buttons :as wizard-buttons]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-chain.core :as rc]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rc/reg-chain
  ::load-user-projects
  (fn [{:keys [db]} _]
    {:db           (assoc db ::pending? true)
     :comm/command {:command :project/find}})
  (fn [{:keys [db]} [_ status response]]
    {:db       (assoc db ::pending? false)
     :dispatch [::entities/merge-entity-db status response]}))


(rf/reg-event-db
  ::set-project-name
  (fn [db [_ name]]
    (assoc db ::project-name name)))


(rf/reg-sub
  ::pending?
  :-> ::pending?)


(rf/reg-sub ::projects
  :<- [::entities/entities {:entity/type :entity.type/project}]
  (fn [projects _]
    (->> projects
         (filter (complement (du/in-state-fn :project.state/closed)))
         (filter #(-> % :granted-permissions :role.project/writer)))))


(rf/reg-sub ::project-id
  :-> ::project-id)


(rf/reg-sub ::project-name
  :-> ::project-name)


(rf/reg-sub ::municipality
  :-> ::municipality)


(rf/reg-sub ::subdivision
  :-> ::subdivision)


(rf/reg-sub ::single-mun
  :-> ::single-mun)


(rf/reg-sub ::selected-project
  :<- [::project-id]
  (fn [project-id]
    (<sub [::entities/entity project-id])))


(rf/reg-sub ::selected-tab
  :-> ::selected-tab)


(rf/reg-event-db ::set-selected-project
  (fn [db [_ id number subdivision]]
    (p/assoc-if db
                ::project-id id
                ::municipality number
                ::subdivision subdivision
                ::single-mun (when number true))))


(rf/reg-event-db ::new-project
  (fn [db [_ name]]
    (-> db
        (assoc ::project-name name)
        (dissoc ::project-id ::municipality ::subdivision ::single-mun))))


(rf/reg-event-db ::use-existing-project
  (fn [db _]
    (dissoc db ::project-name)))


(rf/reg-event-db ::set-selected-tab
  (fn [db [_ id]]
    (assoc db ::selected-tab id)))


(defn project-description [tr pending? projects]
  (if pending?
    [:div.bx--col-xs-12
     [cc/skeleton-text {:paragraph true :line-count 3}]]
    [:div.bx--col-xs-12
     [:p
      (if (seq projects)
        (tr [:wizard/project-description])
        (tr [:wizard/project-description.no-projects]))]]))


(defn my-projects [projects]
  (let [tr         (<sub [:tr])
        lang       (<sub [:language])
        project-id (<sub [::project-id])]
    (into
      (cc/tile-group
        {:name           "project-selection"
         :value-selected (or project-id "")
         :on-change      (fn [id]
                           (let [project                                   (p/find-first projects {:db/id id})
                                 {:municipality/keys [number subdivision]} (:project/municipality project)]
                             (>evt [::set-selected-project id number subdivision])))
         :class-name     "bx--row project-selection"})
      (for [{:keys [:db/id] :project/keys [name structural-address municipality property]} projects]
        (cc/radio-tile
          {:key        id
           :value      id
           :class-name "bx--col-xs-3 project-tile"}
          [:div.project-icon
           (cc/icon
             {:icon        i/document-list
              :description (tr [:select/project] [name])})]
          [:div.project-name
           [:div.font-bold.mb-2 name]
           [:div.leading-tight (str (or (:address/full-address structural-address)
                                        (:property/id property))
                                    ", "
                                    (municipality-model/common-name-province municipality tr lang))]])))))


(defn create-project [{:keys [tr next-page back cancel-link]}]
  (r/with-let [initial-project-name (<sub [::project-name])]
    (let [project-name  (or (<sub [::project-name]) "")
          name-invalid? (< (count project-name) 3)
          pending?      (<sub [::pending?])
          projects      (<sub [::projects])
          project       (<sub [::project-id])
          invalid?      (and (nil? project) name-invalid?)
          selected-id   (or (<sub [::selected-tab])
                            (if (and (not initial-project-name)
                                     (seq projects))
                              :existing
                              :create-new))]
      [:section#create-project-step
       [:div.bx--row>h2.bx--col-xs-12
        (tr [:wizard/project-heading])]
       [:div.bx--row
        [project-description tr pending? projects]]
       (if pending?
         (cc/tabs-skeleton)
         [ui-tabs/tabs
          {:tab-content-class "px-0 py-4"
           :selected-id       selected-id
           :on-change         (fn [id]
                                (>evt [::set-selected-tab id])
                                (case id
                                  :existing   (>evt [::use-existing-project])
                                  :create-new (>evt [::new-project project-name])))
           :tabs              (cond-> []
                                (seq projects)
                                (conj {:id      :existing
                                       :label   (tr [:project/select-existing])
                                       :content (if pending?
                                                  (cc/skeleton-text {})
                                                  [my-projects projects])})
                                true
                                (conj {:id      :create-new
                                       :label   (tr [:project/create-new])
                                       :data-cy "project-selector-project-tab"
                                       :content [:div.w-full.lg:w-1-2
                                                 [ui/text-input
                                                  {:id         "project-name"
                                                   :auto-focus (if (seq projects) false true)
                                                   :on-key-up  #(case (-> % .-key)
                                                                  "Enter" (when-not invalid? next-page)
                                                                  nil)
                                                   :value      project-name
                                                   :on-change  #(>evt [::set-project-name (futil/tval %)])
                                                   :label-text (tr [:project/name-label])}]]}))}])
       [wizard-buttons/buttons tr {:next        {:on-click  next-page
                                                 :disabled? invalid?
                                                 :text      (tr [:next])}
                                   :back        {:on-click back}
                                   :cancel-link cancel-link}]])))
